export default "__VITE_ASSET__Cu0bEzb6__"